import { TIMEOUT_SEC } from "./config";
const recipeContainer = document.querySelector('.recipe');
const timeout = function (s) {
    return new Promise(function (_, reject) {
        setTimeout(function () {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};

export const getJson = async (url) => {
    try {

        const res = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)])
        const data = await res.json();
        if (!res?.ok) throw new Error(`${data?.message} (${res?.status})`)
        return data;
    }
    catch (err) {

        throw err
    }
}
export const convertDate = (date) => {
    const localTime = new Intl.DateTimeFormat("sv-SE", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(date);
    return localTime;
};
export const cleanHistory = () => {
    localStorage.setItem("history", JSON.stringify([]))
}